import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaArrowRight,
} from "react-icons/fa";

const quickLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/service", label: "Our Services" },
  { to: "/products", label: "Products" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact Us" },
];

const services = [
  "T-Shirt Manufacturing",
  "Formal Wear Production",
  "Bulk Order Garments",
  "Custom Design & Stitching",
  "Quality Assurance",
  "Export Services",
];

const socials = [
  { Icon: FaFacebook, label: "Facebook" },
  { Icon: FaInstagram, label: "Instagram" },
  { Icon: FaLinkedin, label: "LinkedIn" },
  { Icon: FaYoutube, label: "YouTube" },
  { Icon: FaWhatsapp, label: "WhatsApp" },
];

const Footer = () => (
  <footer className="bg-gray-900 text-gray-400">
    {/* Top CTA strip */}
    <div className="bg-blue-700">
      <div className="max-w-7xl mx-auto px-4 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div>
          <h3 className="text-white text-xl font-bold">
            Ready to start your bulk order?
          </h3>
          <p className="text-blue-200 text-sm mt-1">
            Get in touch with our team for custom manufacturing quotes.
          </p>
        </div>
        <Link
          to="/contact"
          className="flex-shrink-0 flex items-center gap-2 bg-white text-blue-700 font-semibold px-6 py-3 rounded-full hover:bg-blue-50 transition text-sm shadow-lg"
        >
          Get a Free Quote
          <FaArrowRight size={12} />
        </Link>
      </div>
    </div>

    {/* Main footer */}
    <div className="max-w-7xl mx-auto px-4 pt-14 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <Link to="/">
            <img
              src="/images/logo.png"
              className="w-20 brightness-200 invert opacity-90"
              alt="OM Maruti Creation"
            />
          </Link>
          <p className="mt-5 text-sm leading-relaxed">
            Trusted garment manufacturing company delivering premium quality
            apparel solutions with innovation and excellence since 2006.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {socials.map(({ Icon, label }) => (
              <a
                key={label}
                href="#"
                aria-label={label}
                className="w-8 h-8 rounded-full bg-gray-800 hover:bg-blue-600 flex items-center justify-center transition-colors duration-200"
              >
                <Icon size={14} className="text-gray-300" />
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-white text-sm font-semibold uppercase tracking-wider mb-5">
            Quick Links
          </h4>
          <ul className="space-y-3">
            {quickLinks.map(({ to, label }) => (
              <li key={to}>
                <Link
                  to={to}
                  className="text-sm flex items-center gap-2 hover:text-white hover:translate-x-1 transition-all duration-200 group"
                >
                  <FaArrowRight
                    size={9}
                    className="text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity"
                  />
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-white text-sm font-semibold uppercase tracking-wider mb-5">
            Our Services
          </h4>
          <ul className="space-y-3">
            {services.map((s) => (
              <li key={s}>
                <Link
                  to="/contact"
                  className="text-sm flex items-center gap-2 hover:text-white hover:translate-x-1 transition-all duration-200 group"
                >
                  <FaArrowRight
                    size={9}
                    className="text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity"
                  />
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-white text-sm font-semibold uppercase tracking-wider mb-5">
            Contact Info
          </h4>
          <ul className="space-y-4">
            <li className="flex items-start gap-3 text-sm">
              <FaMapMarkerAlt className="text-blue-500 mt-0.5 flex-shrink-0" />
              <span>
                Peenya 2nd Stage,
                <br />
                Bangalore – 560058
              </span>
            </li>
            <li className="flex items-center gap-3 text-sm">
              <FaEnvelope className="text-blue-500 flex-shrink-0" />
              <a
                href="mailto:info@ommaruticreation.com"
                className="hover:text-white transition"
              >
                info@ommaruticreation.com
              </a>
            </li>
            <li className="flex items-center gap-3 text-sm">
              <FaPhone className="text-blue-500 flex-shrink-0" />
              <a
                href="tel:+910987654321"
                className="hover:text-white transition"
              >
                +91 0987654321
              </a>
            </li>
          </ul>

          {/* Admin link - small and subtle */}
          {/* <div className="mt-8">
            <Link to="/admin/login" className="text-xs text-gray-600 hover:text-gray-400 transition">
              Admin Login →
            </Link>
          </div> */}
        </div>
      </div>
    </div>

    {/* Bottom bar */}
    <div className="border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-600">
        <p>© 2006 OM Maruti Creation. All Rights Reserved.</p>
        <p>Designed with ♥ for premium garment manufacturing</p>
      </div>
    </div>
  </footer>
);

export default Footer;
